module.exports = __webpack_public_path__ + "static/media/2015-image.e418387e.png";